import React from 'react'
import type { CharmImageItem } from './types'

export default function CharmImages({ images }: { images: CharmImageItem[] }) {
    return (
        <>
            {images.map((img, index) => (
                <div key={index}>
                    <img src={img.src} alt={img.alt} />
                </div>
            ))}
        </>
    )
}
